import AuthStore from '@/store/modules/AuthStore';
import httpClient from "./http-client";

const ENDPOINT = "/persona";

export interface PersonaDto {
  id?: number;
  nombre: string;
  apellido: string;
  tipoIdentificacion?: string;
  identificacion?: string;
  sexo?: string;
  fechaNacimiento?: string;
}

export interface PersonaUpdateDto {
  id?: number;
  nombre: string;
  carnetConadis?: string;
  carrerasVisitanteIDs?: number[];
}

class PersonaService {
  getAll(): Promise<PersonaDto[]> {
    return httpClient.get(ENDPOINT).then(response => {
      if (response.data) {
        return response.data;
      }
    });
  }
  update(updateDto: PersonaUpdateDto) {
    /*
    const { carnetConadis } = updateDto;
    if (!carnetConadis) {
      delete updateDto["carnetConadis"];
    }
    */
    return httpClient.put(ENDPOINT + "/" + updateDto.id, updateDto);
  }

  getDependants(): Promise<{ data: PersonaDto[] }> {
    if (AuthStore.loggedIn) {
      return httpClient.get(`${ENDPOINT}/${AuthStore.getPersonaID}/dependants`);
    }

    return Promise.resolve({ data: [] });
  }

  createDependant(personaId: number, dto: PersonaDto): Promise<PersonaDto> {
    return httpClient.post(`${ENDPOINT}/${personaId}/dependants`, dto);
  }

  /**
   * 
   * @returns 
   */
  getPersona(): Promise<PersonaDto | any> {
    if (AuthStore.loggedIn) {
      return httpClient.get(`${ENDPOINT}/${AuthStore.getPersonaID}`).then(response => {
        if (response.data) {
          return response.data;
        }
      });
    }

    return Promise.resolve({ data: null });
  }
}
export default new PersonaService();
